import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import UserAppResource from './UserAppResource';

export const TYPE_WEB = 10;

export const TYPES = {
    TYPE_WEB: TYPE_WEB,
};

class PushSubscriptionAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'push-subscription';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'pushes/subscriptions';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    apiPaths() {
        let apiPaths = super.apiPaths();
        apiPaths = {
            ...apiPaths,
            'subscribeOrUpdate': `${apiPaths.create}/subscribeOrUpdate`,
        };

        return apiPaths;
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'type',
            'webPush',
            'userUuid',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            user: UserAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            user: 'user_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            type: {
                presence: true,
                numericality: true,
            },
            userUuid: {
                type: 'string',
                presence: true,
            },
            webPush: {},
        };
    }

    /**
     * @param subscription {Object}
     */
    async subscribeOrUpdate(subscriptionData) {
        const url = this.apiPaths().subscribeOrUpdate;
        const data = {
            webPush: subscriptionData,
        };

        const response = await this.enginePost(url, data);

        this.syncFromRemoteAppResource(
            response.resources.getFirst(),
        );

        return this;
    }

}

export default PushSubscriptionAppResource;
